import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind("[data-fancybox]", {
  on: {
    "Carousel.change": (instance, event) => {
      const current = instance.getSlide();
      const isProductMainGallery = current?.fancybox == "product-main-gallery";

      if (isProductMainGallery) {
        const event = new CustomEvent("product-gallery-close", {
          bubbles: true,
          detail: {
            index: current.index,
          },
        });

        window.dispatchEvent(event);
      }
    },
  },
});
